<template>
  <div class="container-fluid">
    <div class="row" v-if="loading">
      <div class="col-12 text-center py-5">
        <span class="fa fa-spinner fa-spin fa-3x"></span>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-md-4" v-for="section in sections" :key="section.title">
        <h4 class="text-center mb-3">{{ section.title }}</h4>
        <div class="kanbanPreview-bx">
          <div class="card mb-3" v-for="(item, index) in section.items" :key="section.title + index">
            <div class="card-body sub-card">
              <p class="card-text"><strong>{{ item.C5_NUM || item.DAI_PEDIDO || item.E1_NUM }}</strong></p>
              <p class="card-text">{{ item.B1_DESC }}</p>
              <p class="card-text" v-if="item.C6_QTDVEN">Qtd: {{ item.C6_QTDVEN }}</p>
            </div>
          </div>
          <p v-if="!section.items.length" class="text-muted text-center">Nenhum registro</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      unbilled: [],
      billed: [],
      delivery: [],
    };
  },
  computed: {
    sections() {
      return [
        { title: "Pedidos a Faturar", items: this.unbilled },
        { title: "Pedidos Faturados", items: this.billed },
        { title: "Entregas em Andamento", items: this.delivery },
      ];
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      const api = this.$store.state.api;
      this.loading = true;
      try {
        const [unbilledRes, billedRes, deliveryRes] = await Promise.all([
          axios.get(api + "orders/?page=1&cTop=10&status=unbilled"),
          axios.get(api + "orders/?page=1&cTop=10&status=billed"),
          axios.get(api + "deliveries/?page=1&cTop=10&status=pending"),
        ]);
        this.unbilled = unbilledRes.data.data.ZOOM || [];
        this.billed = billedRes.data.data.ZOOM || [];
        this.delivery = deliveryRes.data.data.ZOOM || [];
      } catch (e) {
        this.$toast.error("Erro ao carregar resumo geral");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
